import { render } from "./CalendarPage.vue?vue&type=template&id=4aaacebb&scoped=true"
import script from "./CalendarPage.vue?vue&type=script&lang=js"
export * from "./CalendarPage.vue?vue&type=script&lang=js"

import "./CalendarPage.vue?vue&type=style&index=0&id=4aaacebb&scoped=true&lang=css"
import "./CalendarPage.vue?vue&type=style&index=1&id=4aaacebb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aaacebb"]])

export default __exports__